// services/intercomService.js
import apiClient from "config/api";

/**
 * Tickets API calls
 */
const getTickets = async (params = {}) => {
  const response = await apiClient.get("/admin/intercom/tickets", { params });
  return response;
};

const getMoreTickets = async (params = {}) => {
  return getTickets(params);
};

const getTicketById = async (ticketId) => {
  return apiClient.get(`/admin/intercom/tickets/${ticketId}`);
};

const replyToTicket = async (ticketId, data) => {
  return apiClient.post(`/admin/intercom/tickets/${ticketId}/reply`, data);
};

const closeTicket = async (ticketId) => {
  return apiClient.post(`/admin/intercom/tickets/${ticketId}/close`);
};

const openTicket = async (ticketId) => {
  return apiClient.post(`/admin/intercom/tickets/${ticketId}/open`);
};

const assignTicket = async (ticketId, assigneeId) => {
  return apiClient.post(`/admin/intercom/tickets/${ticketId}/assign`, {
    assigneeId,
  });
};

const snoozeTicket = async (ticketId, snoozedUntil) => {
  return apiClient.post(`/admin/intercom/tickets/${ticketId}/snooze`, {
    snoozedUntil,
  });
};

/**
 * Conversations API calls
 */

const getConversations = async (params = {}) => {
  const response = await apiClient.get("/admin/intercom/chat/conversations", {
    params,
  });
  return response;
};

const getMoreConversations = async (params = {}) => {
  return getConversations(params);
};

const getConversationMessages = async (conversationId) => {
  return apiClient.get(
    `/admin/intercom/chat/conversations/${conversationId}/messages`
  );
};

const sendMessage = async (conversationId, message) => {
  return apiClient.post(
    `/admin/intercom/chat/conversations/${conversationId}/send`,
    { message }
  );
};

const markConversationAsRead = async (conversationId) => {
  return apiClient.put(
    `/admin/intercom/chat/conversations/${conversationId}/read`
  );
};

const getUnreadCounts = async () => {
  return apiClient.get("/admin/intercom/unread-counts");
};

/**
 * Admins API calls
 */

const getAdmins = async () => {
  return apiClient.get("/admin/intercom/admins");
};

const getAdminById = async (adminId) => {
  return apiClient.get(`/admin/intercom/admins/${adminId}`);
};

/**
 * Ticket Types API calls
 */

const getTicketTypes = async () => {
  return apiClient.get("/admin/intercom/ticket-types");
};

const getTicketTypeById = async (ticketTypeId) => {
  return apiClient.get(`/admin/intercom/ticket-types/${ticketTypeId}`);
};

export {
  // Tickets
  getTickets,
  getMoreTickets,
  getTicketById,
  replyToTicket,
  closeTicket,
  openTicket,
  assignTicket,
  snoozeTicket,

  // Conversations
  getConversations,
  getMoreConversations,
  getConversationMessages,
  sendMessage,
  markConversationAsRead,
  getUnreadCounts,

  // Admins
  getAdmins,
  getAdminById,

  // Ticket Types
  getTicketTypes,
  getTicketTypeById,
};
